import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b64551c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100vh"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
const _hoisted_3 = { style: {"padding":"14px"} }
const _hoisted_4 = { class: "bottom" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref } from 'vue'
    
    import { useRoute, useRouter } from 'vue-router';
  
    
export default /*#__PURE__*/_defineComponent({
  __name: 'CardImg-wap',
  props: ['value'],
  setup(__props) {

    const router = useRouter();
    const redirect = (path: string) => {
      router.push(path);
    }
  
    const titles = __props;
    

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titles.value, (title) => {
      return (_openBlock(), _createBlock(_component_el_row, {
        key: title.id
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_el_col, {
            span: 24,
            offset: 0
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { "body-style": { padding: '0px' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, {
                    class: "custom-card",
                    "body-style": { padding: '0px' },
                    style: _normalizeStyle({ backgroundImage: `url('${require(`@/assets/${title.img}`)}')` }),
                    onClick: ($event: any) => (redirect(title.route))
                  }, null, 8, ["style", "onClick"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(title.title), 1),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("time", _hoisted_5, _toDisplayString(title.desc), 1),
                      _createVNode(_component_el_button, {
                        text: "",
                        class: "button",
                        onClick: ($event: any) => (redirect(title.route))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Check It")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024),
          _hoisted_6
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _hoisted_7
  ]))
}
}

})